import { Link, useLocation, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, Calendar, Mail, LogOut, CreditCard, Star, Instagram } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

const AdminLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    localStorage.removeItem("adminToken");
    await logout();
    toast.success("Logged out successfully");
    navigate("/admin");
  };

  const navItems = [
    { name: "Dashboard", path: "/admin/dashboard", icon: LayoutDashboard },
    { name: "Packages", path: "/admin/packages", icon: Package },
    { name: "Bookings", path: "/admin/bookings", icon: Calendar },
    { name: "Payments", path: "/admin/payments", icon: CreditCard },
    { name: "Reviews & Leads", path: "/admin/testimonials", icon: Star },
    { name: "Insta Feed", path: "/admin/insta-feed", icon: Instagram },
    { name: "Inquiries", path: "/admin/inquiries", icon: Mail },
  ];

  return (
    <div className="min-h-screen bg-muted">
      {/* Sidebar */}
      <div className="fixed left-0 top-0 h-full w-64 bg-primary text-primary-foreground p-6">
        <div className="mb-8">
          <h1 className="text-2xl font-serif font-semibold">Admin Panel</h1>
          <p className="text-sm text-primary-foreground/70">Andaman Avalon</p>
        </div>

        <nav className="space-y-2">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              data-testid={`admin-nav-${item.name.toLowerCase()}`}
              className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                location.pathname === item.path
                  ? "bg-secondary text-secondary-foreground"
                  : "hover:bg-primary-foreground/10"
              }`}
            >
              <item.icon size={20} />
              <span>{item.name}</span>
            </Link>
          ))}
        </nav>

        <button
          onClick={handleLogout}
          data-testid="admin-logout-btn"
          className="flex items-center space-x-3 px-4 py-3 rounded-lg hover:bg-primary-foreground/10 transition-colors mt-auto absolute bottom-6 left-6 right-6"
        >
          <LogOut size={20} />
          <span>Logout</span>
        </button>
      </div>

      {/* Main Content */}
      <div className="ml-64 p-8">
        {children}
      </div>
    </div>
  );
};

export default AdminLayout;
